const { UPDATE_HOSPITALWARDLIST, DELETE_HOSPITALWARDLIST } = require('../../constant');

const hospitalWardList = (state = null, action) => {
  const { type, data } = action;
  switch (type) {
    case UPDATE_HOSPITALWARDLIST:
      return data;
    case DELETE_HOSPITALWARDLIST:
      return data;
    default:
      return state;
  }
};

export { hospitalWardList };
